import { initFederation } from '@angular-architects/module-federation-runtime';
import { environment } from './environments/environment';

console.log("Initialisation de l'Host avec les URLs Dokploy...");

initFederation({
  'contracts': environment.REMOTE_CONTRACTS_URL,
  'products': environment.REMOTE_PRODUCTS_URL,
  'users': environment.REMOTE_USERS_URL,
  'finances': environment.REMOTE_FINANCES_URL,
})
  .then(() => import('./bootstrap'))
  .catch(err => {
    console.error('ERREUR CRITIQUE FEDERATION :', err);
    document.body.innerHTML = `<div style="color:red; padding:20px;">Erreur de configuration : ${err.message}</div>`;
  });